import { usePathname, useRouter } from 'next/navigation';

import useMobileStore from '@/store/mobileStore';
import { usePathStore } from '@/store/pathStore';
import { appToClose } from '@/utils/js/webView';

export default function CommonBackButton({
  text,
  onClick,
}: {
  text?: string;
  onClick?: () => void;
}) {
  const router = useRouter();
  const pathName = usePathname();
  const { noPreviousPath, resetPath } = usePathStore();
  const { isWebView } = useMobileStore();

  const handleClickBackBtn = () => {
    if (onClick) {
      onClick();
    }

    if (isWebView && noPreviousPath && pathName === noPreviousPath) {
      resetPath();
      appToClose();
    } else {
      router.back();
    }
  };

  return (
    <>
      <button className="btn btn_back" type="button" onClick={handleClickBackBtn}>
        {text ?? <span className="text_blind">뒤로가기</span>}
      </button>
    </>
  );
}
